/**
 * 业务 TTS 音色
 * 由 COURSE_TTS_API 在 tts1（Cibei/Kokoro）与 tts3（Edge Neural）间切换。
 * 旧 Azure 名可由后端映射，设置层用 normalizeTtsVoice 收敛到列表项。
 */

import { COURSE_TTS_API } from '@/config/ttsApiSwitch'

// ========== tts1 音色（Cibei/Kokoro）保留，切回 tts1 时启用 ==========
// 列表与文案对齐 Demo https://tts.cibeiai.com/web/（美式 20 + 英式 8）
// 当前可选：美式女 哈特；美式男 芬里尔；英式女 艾玛；英式男 费布尔（伊莎贝拉已下架）
const TTS_VOICE_OPTIONS_TTS1 = [
  // —— 美式英语 ——
  // { label: '美式-女声-莎拉 / Sarah', value: 'af_sarah' },

  // { label: '美式-女声-贝拉 / Bella', value: 'af_bella' },

  // { label: '美式-女声-阿洛伊 / Alloy', value: 'af_alloy' },
  // { label: '美式-女声-埃奥德 / Aoede', value: 'af_aoede' },
  { label: '美式-女声-哈特 / Heart', value: 'af_heart' },
  // { label: '美式-女声-杰西卡 / Jessica', value: 'af_jessica' },
  { label: '美式-女声-科瑞 / Kore', value: 'af_kore' },
  // { label: '美式-女声-妮可 / Nicole', value: 'af_nicole' },
  // { label: '美式-女声-诺娃 / Nova', value: 'af_nova' },
  // { label: '美式-女声-里弗 / River', value: 'af_river' },
  // { label: '美式-女声-斯凯 / Sky', value: 'af_sky' },

  { label: '美式-男声-芬里尔 / Fenrir', value: 'am_fenrir' },

  { label: '美式-男声-亚当 / Adam', value: 'am_adam' },

  // { label: '美式-男声-艾可 / Echo', value: 'am_echo' },
  // { label: '美式-男声-埃里克 / Eric', value: 'am_eric' },
  // { label: '美式-男声-利亚姆 / Liam', value: 'am_liam' },
  // { label: '美式-男声-迈克尔 / Michael', value: 'am_michael' },
  // { label: '美式-男声-奥尼克斯 / Onyx', value: 'am_onyx' },
  { label: '美式-男声-帕克 / Puck', value: 'am_puck' },
  // { label: '美式-男声-桑塔 / Santa', value: 'am_santa' },

  // —— 英式英语 ——
  // { label: '英式-女声-伊莎贝拉 / Isabella', value: 'bf_isabella' },

  { label: '英式-女声-艾玛 / Emma', value: 'bf_emma' },

  // { label: '英式-女声-爱丽丝 / Alice', value: 'bf_alice' },
  // { label: '英式-女声-莉莉 / Lily', value: 'bf_lily' },

  { label: '英式-男声-费布尔 / Fable', value: 'bm_fable' },

  // { label: '英式-男声-乔治 / George', value: 'bm_george' },

  { label: '英式-男声-丹尼尔 / Daniel', value: 'bm_daniel' },
  // { label: '英式-男声-刘易斯 / Lewis', value: 'bm_lewis' },
]

/** tts1 默认：美式-女声-哈特 */
const DEFAULT_TTS_VOICE_TTS1 = 'af_heart'
const LEARNING_MODULE_FIXED_US_VOICE_TTS1 = 'af_heart'
const LEARNING_MODULE_FIXED_UK_VOICE_TTS1 = 'bf_emma'

// ========== tts3 音色（Edge Neural）当前启用 ==========
// 文案对齐 edge-tts-exe `RECOMMENDED_VOICES`：名称 + 英/美音 + 性别（+ 默认）
const TTS_VOICE_OPTIONS_TTS3 = [
  // —— 英音 ——
  { label: '英式-女声-Sonia（默认）', value: 'en-GB-SoniaNeural' },
  { label: '英式-男声-Ryan', value: 'en-GB-RyanNeural' },
  // { label: '英式-女声-Libby', value: 'en-GB-LibbyNeural' },
  // { label: '英式-男声-Thomas', value: 'en-GB-ThomasNeural' },

  // —— 美音 ——
  { label: '美式-女声-Jenny', value: 'en-US-JennyNeural' },
  { label: '美式-男声-Guy', value: 'en-US-GuyNeural' },
  // { label: '美式-女声-Aria', value: 'en-US-AriaNeural' },
  // { label: '美式-男声-Christopher', value: 'en-US-ChristopherNeural' },
  // { label: '美式-女声-Michelle', value: 'en-US-MichelleNeural' },
]

/** tts3 默认：Sonia */
const DEFAULT_TTS_VOICE_TTS3 = 'en-GB-SoniaNeural'
const LEARNING_MODULE_FIXED_UK_VOICE_TTS3 = 'en-GB-SoniaNeural'
const LEARNING_MODULE_FIXED_US_VOICE_TTS3 = 'en-US-JennyNeural'

const USE_TTS3 = COURSE_TTS_API === 'tts3'

export const ttsVoiceOptions = USE_TTS3 ? TTS_VOICE_OPTIONS_TTS3 : TTS_VOICE_OPTIONS_TTS1
export const DEFAULT_TTS_VOICE = USE_TTS3 ? DEFAULT_TTS_VOICE_TTS3 : DEFAULT_TTS_VOICE_TTS1
export const LEARNING_MODULE_FIXED_US_VOICE = USE_TTS3
  ? LEARNING_MODULE_FIXED_US_VOICE_TTS3
  : LEARNING_MODULE_FIXED_US_VOICE_TTS1
export const LEARNING_MODULE_FIXED_UK_VOICE = USE_TTS3
  ? LEARNING_MODULE_FIXED_UK_VOICE_TTS3
  : LEARNING_MODULE_FIXED_UK_VOICE_TTS1

const ACTIVE_VOICE_SET = new Set(ttsVoiceOptions.map((v) => v.value))

/**
 * 设置/展示用：非法或历史音色 → 当前可选列表项。
 * 请求层不必再调；后端亦可映射旧名。
 */
export function normalizeTtsVoice (speaker) {
  const s = String(speaker === null || speaker === undefined ? '' : speaker).trim()
  if (!s) return DEFAULT_TTS_VOICE
  if (ACTIVE_VOICE_SET.has(s)) return s
  const lower = s.toLowerCase()
  if (lower.startsWith('af_') || lower.startsWith('am_') || lower.startsWith('en-us')) {
    return LEARNING_MODULE_FIXED_US_VOICE
  }
  if (lower.startsWith('bf_') || lower.startsWith('bm_') || lower.startsWith('en-gb')) {
    return LEARNING_MODULE_FIXED_UK_VOICE
  }
  return DEFAULT_TTS_VOICE
}
